import { Package } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const OrdersIcon = createNavigationLucideIcon(Package);
